import { useQueryClient } from '@tanstack/react-query';

import { type LivePetContent } from '../lib';
import { LIVE_PET_CONTENT_KEY } from './queryKey';

export const useLivePetContentQuery = () => {
    const queryClient = useQueryClient();

    const livePetData = queryClient.getQueryData<LivePetContent>([LIVE_PET_CONTENT_KEY]);

    return { livePetData };
};
